window.incrementValue = function(id) {
    const input = document.getElementById(id);
    const step = parseFloat(input.step) || 1;
    const max = input.max ? parseFloat(input.max) : Infinity;
    const newValue = parseFloat((parseFloat(input.value || 0) + step).toFixed(2));

    if (newValue <= max) {
        input.value = newValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
}

window.decrementValue = function(id) {
    const input = document.getElementById(id);
    const step = parseFloat(input.step) || 1;
    const min = input.min ? parseFloat(input.min) : -Infinity;
    const newValue = parseFloat((parseFloat(input.value || 0) - step).toFixed(2));

    if (newValue >= min) {
        input.value = newValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
